namespace $.$$ {

	$mol_style_define( $shm_prereleasefixtureapp, {
		flex: { direction: 'column' },
		gap: $mol_gap.block,
		padding: $mol_gap.block,
		Title: { font: { size: '2rem', weight: 'bold' } },
	} )

}
